import angular from 'angular';

DialogConfirmService.$inject = ['$rootScope', '$q', '$compile', '$templateCache', '$http', '$timeout', '$log'];
export default function DialogConfirmService($rootScope, $q, $compile, $templateCache, $http, $timeout, $log) {

    var _this = this;
    _this.dialogs = {};

    this.open = function (template, options) {
        const TEMPLATE = require('./template-confirm.html');
        const ID = 'template-dialog-confirm';

        if (!angular.isDefined(template)) throw "dialogService requires template in call to open";

        var botonOk = 'Aceptar', botonCancel = 'Cancelar', titulo = "Confirmar";

        if (angular.isDefined(options)) {
            if (angular.isDefined(options.botonOk)) botonOk = options.botonOk;
            if (angular.isDefined(options.botonCancel)) botonCancel = options.botonCancel;
        }

        var dialogOptions = {
            modal: true,
            autoOpen: false,
            minWidth: 250,
            resizable: false,
            title: titulo,
            buttons: [
                {
                    text: botonOk,
                    click: function () {
                        _this.close(ID, dialog.scope);
                    }
                },
                {
                    text: botonCancel,
                    click: function () {
                        _this.cancel(ID);
                    }
                }
            ]
        };

        if (angular.isDefined(options)) angular.extend(dialogOptions, options);

        // Initialize our dialog structure
        var dialog = {scope: null, ref: null, deferred: $q.defer()};

        // Get the template from teh cache or url
        $timeout(() => {
            // Create a new scope, inherited from the parent.
            dialog.scope = $rootScope.$new();

            dialog.scope.templateUser = template;
            // dialog.scope.dialog.texto = template;

            var dialogLinker = $compile(TEMPLATE);
            dialog.ref = $(dialogLinker(dialog.scope));

            // Handle the case where the user provides a custom close and also
            // the case where the user clicks the X or ESC and doesn't call
            // close or cancel.
            var customCloseFn = dialogOptions.close;
            dialogOptions.close = function (event, ui) {
                if (customCloseFn) customCloseFn(event, ui);
                cleanup(ID);
            };

            // Initialize the dialog and open it
            dialog.ref.dialog(dialogOptions);
            dialog.ref.dialog("open");

            // Cache the dialog
            _this.dialogs[ID] = dialog;
        });

        // Return our cached promise to complete later
        return dialog.deferred.promise;
    };

    this.close = function (id, result) {

        // Get the dialog and throw exception if not found
        var dialog = _this.getExistingDialog(id);

        // Notify those waiting for the result
        // This occurs first because the close calls the close handler on the
        // dialog whose default action is to cancel.

        dialog.deferred.resolve(result);

        // Close the dialog (must be last)
        dialog.ref.dialog("close");
    };

    this.cancel = function (id) {
        // Get the dialog and throw exception if not found
        var dialog = _this.getExistingDialog(id);

        // Notify those waiting for the result
        // This occurs first because the cancel calls the close handler on the
        // dialog whose default action is to cancel.
        dialog.deferred.reject();

        // Cancel and close the dialog (must be last)
        dialog.ref.dialog("close");
    };

    function cleanup(id) {
        // Get the dialog and throw exception if not found
        var dialog = _this.getExistingDialog(id);

        // This is only called from the close handler of the dialog
        // in case the x or escape are used to cancel the dialog. Don't
        // call this from close, cancel, or externally.
        dialog.deferred.reject();
        dialog.scope.$destroy();

        // Remove the object from the DOM
        dialog.ref.remove();

        // Delete the dialog from the cache
        delete _this.dialogs[id];
    }

    this.getExistingDialog = function (id) {
        // Get the dialog from the cache
        var dialog = _this.dialogs[id];
        // Throw an exception if the dialog is not found
        if (!angular.isDefined(dialog)) throw "DialogService does not have a reference to dialog id " + id;
        return dialog;
    };

// Since IE8 doesn't support string.trim, provide a manual method.
    function trim(string) {
        return string ? string.replace(/^\s+|\s+$/g, '') : string;
    }
}